import { useAuthStore } from '@/store/authStore';
import { useClientDocumentsConfig } from '@/hooks/useClientDocumentsConfig';

/**
 * Blocco full-screen per utenti non admin quando maintenanceMode è attivo sul server.
 * La route /login non usa AppLayout, quindi gli admin possono autenticarsi.
 */
export function MaintenanceModeOverlay() {
  const { user } = useAuthStore();
  const { maintenanceMode, loading } = useClientDocumentsConfig();
  const isAdmin = user?.role === 'ADMIN';

  if (loading || !maintenanceMode || isAdmin) return null;

  return (
    <div
      className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-gray-900/85 px-6 text-center text-white backdrop-blur-sm"
      role="alertdialog"
      aria-live="assertive"
      aria-label="Sito in manutenzione"
    >
      <h1 className="mb-3 text-2xl font-semibold tracking-tight">Sito in manutenzione</h1>
      <p className="max-w-md text-gray-200">
        Il gestionale non è disponibile per il tuo profilo. Contatta un amministratore o riprova più tardi.
      </p>
      <p className="mt-6 max-w-md text-sm text-gray-400">
        Per chiudere la sessione puoi chiudere questa finestra del browser.
      </p>
    </div>
  );
}
